import React, { Component } from "react";
import PropTypes from "prop-types";

import "./App.css";
import IronSourceInitializerContainer from "./package-ironsource/containers/IronSourceInitializerContainer";
import PageTransitionSequence from "./components/PageTransitionSequence";
import RewardAdContainer from "./package-reward-ads-overlay/containers/RewardAdContainer";
import AudioContainer from "./containers/AudioContainer";
import { playSound } from "./utils/audio-helper";
import { GAME_STATUS_HINT_CLICK, GAME_STATUS_REVEAL_ALL_ANSWERS_CLICK } from "./actions/game";
import AnalyticsContainer from "./containers/AnalyticsContainer";

class App extends Component {
  constructor(props) {
    super(props);
    const self = this;

    self.state = {
      gsntvwc: null
    };
  }

  renderReward() {
    if (this.props.shouldRewardPoints) {
      console.log("this.renderReward");
      window.GSNTVWC.addNewsletterEvents(()=>{
        this.props.setShouldRewardPoints(false);
        window.GSNTVWC.removeNewsletterEvents();
      }, ()=>{
        this.props.addGamePoints(200);
        this.props.setShouldRewardPoints(false);
        this.props.setGameAwardRewardStatus();
        window.GSNTVWC.removeNewsletterEvents();
      });

      return (
        <gsntv-wc-newsletter-module
          storage-name="chainreactionwebgame"
          email-list-type="chain-reaction-webgame"
          watchAdLabel="Watch a Video instead"
          game-id="chain-reaction-webgame"
        >
        </gsntv-wc-newsletter-module>
      );
      
      return <RewardAdContainer
        showVideoAd={true}
        handleVideoOverlayClose={()=>{
          this.props.addGamePoints(200);
          this.props.setShouldRewardPoints(false);
          this.props.setGameAwardRewardStatus();
        }} 
        handleExitShowVideoAd={()=>{
           this.props.setShouldRewardPoints(false);
        }}
        videoAdType={'test'}
        showNewsletter={true}
        />
    }

    if (this.props.gameStatus === GAME_STATUS_HINT_CLICK || this.props.gameStatus === GAME_STATUS_REVEAL_ALL_ANSWERS_CLICK) {

      window.GSNTVWC.addNewsletterEvents(()=>{
        this.props.resetGameStatus();
        window.GSNTVWC.removeNewsletterEvents();
      }, ()=>{
        this.props.setGameAwardRewardStatus();
        window.GSNTVWC.removeNewsletterEvents();
      });

      return (
        <gsntv-wc-newsletter-module
          storage-name="chainreactionwebgame"
          email-list-type="chain-reaction-webgame"
          watchAdLabel="Watch a Video instead"
          game-id="chain-reaction-webgame"
        >
        </gsntv-wc-newsletter-module>
      );
      
      return <RewardAdContainer
        showVideoAd={true}
        handleVideoOverlayClose={()=>{
          this.props.setGameAwardRewardStatus();
        }} 
        handleExitShowVideoAd={()=>{
          this.props.resetGameStatus();
        }}
        videoAdType={'test'}
        showNewsletter={true}
        />
    }
  }

  componentDidMount() {
    const self = this;

    console.log("quizQuestions:", self.props.quizQuestions);
    self.props.setGameData(self.props.quizQuestions);
	}
  
  
  componentDidUpdate(prevState, prevProps) {
    
    if (this.props.sounds !== [] && prevProps.sounds !== this.props.sounds) {
      // playSound(this.props.sounds, 'theme');
		}
	}

  render() {
    return (
      <div id="app-container">
        <PageTransitionSequence sounds={this.props.sounds} />
        {this.renderReward()}
        <AudioContainer />
        <AnalyticsContainer />
      </div>
    );
  }
}

App.propTypes = {
  angle: PropTypes.number.isRequired,
  quizQuestions: PropTypes.array.isRequired,
  gameData: PropTypes.array.isRequired,
  setGameData: PropTypes.func.isRequired,
  randomizedGameData: PropTypes.func.isRequired
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js